function invoiceBulkDuplicate(UserInfo, filtersUtils, Alert, $filter, DateUtils) {
    return {
        restrict: 'AE',
        scope: {},
        templateUrl: require('../../templates/duplicate-button.html'),
        controller: function ($scope, Task) {
            /***********************************************************************************************************
            * Controller Attributes
            ***********************************************************************************************************/
            var $translate = $filter('translate');

            /***********************************************************************************************************
            * Scope Attributes
            ***********************************************************************************************************/
            $scope.flagConfirmDuplicate = false;
            $scope.listToDuplicate = [];
            $scope.start_date = new Date;
            $scope.finish_date = new Date;

            
            $scope.canAddInvoice = function() {
                return UserInfo.hasPerm('invoices.add_invoice')
            }

            /***********************************************************************************************************
            * Scope Watchers
            ***********************************************************************************************************/
            $scope.$on("selectedItemsChange", function (e, selectedItemsChange) {
                $scope.listToDuplicate = selectedItemsChange;
            });

            $scope.$on("selectedCounterChange", function (e, selectedCounterChange) {
                $scope.counter = selectedCounterChange;
            });

            /***********************************************************************************************************
            * Controller Methods
            ***********************************************************************************************************/
            function performRequest(ids) {
                let json = {
                    ids: ids,
                    start_date : DateUtils.transformToRESTyDate($scope.start_date),
                    finish_date : DateUtils.transformToRESTyDate($scope.finish_date)
                };
                let task = new Task();
                task.type = 'DUPI';
                task.params = json;
                task.start().then(function (data, status, headers, config) {
                    Alert.createAlert('success', $translate('INVOICES.BULK_DUPLICATE_INVOICES_SUCCESS'), true);
                    $scope.backgroundTasks.push(data.data.id);
                }, function (data, status, headers, config) {
                    Alert.createAlert('danger', $translate('INVOICES.BULK_DUPLICATE_INVOICES_ERROR'), true);
                })

            }

            /***********************************************************************************************************
            * Scope Methods
            ***********************************************************************************************************/
            $scope.confirmDuplication = function () {
                $scope.flagConfirmDuplicate = true;
            };

            $scope.clickNo = function () {
                $scope.flagConfirmDuplicate = false;
            };

            $scope.clickYes = function () {
                let ids = filtersUtils.getItemsToDownloadToInt($scope.listToDuplicate);
                performRequest(ids);
            };
        }
    }
}

export { invoiceBulkDuplicate }
